import TransitApi from './base'
import { createFormData } from '@/helpers/TransitHelper'

export default {
  // TODO: Add search, filters and sort params
  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/batch/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getAllExpired(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/batch/list-expired?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/batch/details/${params.id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async deleteById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/batch/delete/${params.batchNumber}`)
      return result
    } catch (error) {
      return error.response
    }
  },

  async deleteAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/batch/delete`, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async getBasicList(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      let result = await Api.get(`/batch/basic-list?${queryString}`)
      return result.data
    } catch (error) {
      return null
    }
  },

  async getBasicListByLaboratory(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      let result = await Api.get(`/batch/basic-list-by-labs?${queryString}`)
      return result.data
    } catch (error) {
      return null
    }
  },

  async import(params) {
    try {
      const Api = TransitApi.getSecureInstanceMultipart()
      const path = '/batch/import'
      const data = createFormData(params)

      const result = await Api.post(path, data)
      return result
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/batch/details/${params.id}` : '/batch/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async sendEmailsExpired(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/batch/send-emails-expired-batch', params)
      return result
    } catch (error) {
      return error.response
    }
  },
}
